module.exports = __webpack_public_path__ + "static/media/button-round-arrow-right.507f41f0.svg";